module.exports = __webpack_public_path__ + "img/leftFixed.e526c06f.png";